export const RESET = 'PRODUCT_UPDATE_RESET'
export const SET_ERROR = 'PRODUCT_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'PRODUCT_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'PRODUCT_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'PRODUCT_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'PRODUCT_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'PRODUCT_UPDATE_UPDATE_RETRIEVED'
export const SET_FILES = 'PRODUCT_UPDATE_FILES'
